// extracted by mini-css-extract-plugin
export default {"tab":"MessageCenterTab_tab__3R08o","newMessagesIndicator":"MessageCenterTab_newMessagesIndicator__zYE4P","tabActive":"MessageCenterTab_tabActive__tYSyW"};